import { observer } from 'mobx-react-lite'
import React from 'react'

import Divider from '@mui/material/Divider'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import Stack from '@mui/material/Stack'

import { Text } from '@mxenabled/mxui'

import { CurrencyText } from '../../common/'

import { fromTimestampToMonthYear } from '../../core/utils/DateUtil'

import { NetWorth } from '../../core/types/NetWorth'

interface NetWorthListItemProps {
  item: NetWorth
  getStyles: (item: NetWorth) => { backgroundColor: string; borderBottom: string; color: string }
  isHovered: boolean
  isSelected: boolean
  onItemClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>, dataIndex: number) => void
  onMouseEnter: (dataIndex: number) => void
  onMouseLeave: () => void
}

const NetWorthListItem: React.FC<NetWorthListItemProps> = ({
  item: dataPoint,
  getStyles,
  isHovered = false,
  isSelected = false,
  onItemClick,
  onMouseEnter,
  onMouseLeave,
}) => {
  const [listItemStyles, setListItemStyles] = React.useState({
    color: '',
  })

  React.useEffect(() => {
    setListItemStyles(getStyles(dataPoint))
  }, [isHovered, isSelected])

  return (
    <React.Fragment key={dataPoint.x}>
      <ListItem
        sx={{
          ...listItemStyles,
          minHeight: 44,
          '&:hover': { color: isSelected ? 'inherit' : listItemStyles.color },
        }}
      >
        <ListItemButton
          onClick={(event) => onItemClick?.(event, dataPoint.x)}
          onMouseEnter={() => onMouseEnter(dataPoint.x)}
          onMouseLeave={() => onMouseLeave()}
          sx={{ minHeight: 20, padding: 12 }}
        >
          <ListItemText
            primary={
              <Stack direction="row" justifyContent="space-between" sx={{ fontWeight: 400 }}>
                <Text variant="body1">{fromTimestampToMonthYear(dataPoint.x)}</Text>
                <CurrencyText amount={dataPoint.y} sx={{ color: 'inherit' }} variant="body1" />
              </Stack>
            }
          />
        </ListItemButton>
      </ListItem>
      <Divider />
    </React.Fragment>
  )
}

export default observer(NetWorthListItem)
